<script>
import SubHeader from '@components/sub-header'
import CustomArrow from '@components/custom-arrow'

export default {
  name: 'BillingInformation',
  components: {
    SubHeader,
    CustomArrow,
  },
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      billingInformation: '',
      paymentMethod: '',
      openedPanelCost: 0,
      openedPanelDiscounts: 0,
      openedPanelTotal: 0,
    }
  },
  created() {
    this.billingInformation = this.componentData.data
    this.paymentMethod = this.componentData.payment_method
  },
  mounted() {
    const vExpansionHeaders = document
      .getElementById('billingInfo')
      .getElementsByClassName('v-expansion-panel__header')
    for (let header of vExpansionHeaders) {
      header.addEventListener('click', hiddeTotal)
    }
    function hiddeTotal() {
      const elementToHide = this.getElementsByTagName('span')[0]
      if (elementToHide.style.display === 'none') {
        elementToHide.style.display = 'block'
      } else {
        elementToHide.style.display = 'none'
      }
    }
  },
}
</script>

<template>
  <div
    id="billingInfo"
    :class="$style.container"
  >
    <template>
      <!-- <SubHeader :text="componentData.title"/> -->

      <v-expansion-panel
        :class="$style.panel"
        v-model="openedPanelCost"
      >
        <v-expansion-panel-content :class="$style.panel__container">
          <div
            slot="header"
            :class="$style.container__header">
            <h6>
              {{ $t('COMMON.COSTS') }}
              <span :style="{ display: openedPanelCost === 0 ? 'none' : 'block' }">
                {{ billingInformation.subtotal_user_charges_str }}
              </span>
            </h6>

          </div>

          <div
            slot="actions"
            :class="$style.panel__action"
          >
            <CustomArrow
              :class="$style.panel__action__icon"
              :direction="openedPanelCost === 0 ? 'up' : 'down'"
            />
          </div>

          <hr :class="$style.container__simple">
          <div :class="$style.container__body">
            <p v-if="billingInformation.subtotal">
              {{ $t('WIDGETS.BILLING_INFORMATION.SUBTOTAL_PRODUCTS') }}
              <span>{{ billingInformation.subtotal_str }}</span>
            </p>
            <p v-if="billingInformation.delivery_cost">
              {{ $t('WIDGETS.BILLING_INFORMATION.DELIVERY_COST') }}
              <span>{{ billingInformation.delivery_cost_str }}</span>
            </p>
            <p v-if="billingInformation.whim_cost">
              {{ $t('WIDGETS.BILLING_INFORMATION.WHIM_COST') }}
              <span>{{ billingInformation.whim_cost_str }}</span>
            </p>
            <p v-if="billingInformation.tip">
              {{ $t('COMMON.TIP') }}
              <span>{{ billingInformation.tip_str }}</span>
            </p>
            <p v-if="billingInformation.diffs_personal_shoppers">
              {{ $t('WIDGETS.BILLING_INFORMATION.DIFFS_PERSONAL_SHOPPER') }}
              <span>{{ billingInformation.diffs_personal_shoppers_str }}</span>
            </p>
            <p v-if="billingInformation.other_total_charges">
              {{ $t('WIDGETS.BILLING_INFORMATION.OTHER_TOTAL_CHARGES') }}
              <span>{{ billingInformation.other_total_charges_str }}</span>
            </p>
            <hr v-if="billingInformation.subtotal_user_charges" >
            <p
              :class="$style.containerBold">
              {{ $t('WIDGETS.BILLING_INFORMATION.TOTAL_COSTS') }}
              <span
                :class="$style.containerBold"
              >{{ billingInformation.subtotal_user_charges_str }}</span>
            </p>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel
        v-if="billingInformation.subtotal_user_discounts"
        :class="$style.panel"
        v-model="openedPanelDiscounts"
      >
        <v-expansion-panel-content :class="$style.panel__container">

          <div
            slot="header"
            :class="$style.container__header">
            <h6>
              {{ $t('WIDGETS.BILLING_INFORMATION.DISCOUNTS') }}
              <span
                :style="{
                  display: openedPanelDiscounts === 0 ? 'none' : 'block',
                  color: 'red !important'
              }">
                <b v-if="billingInformation.subtotal_user_discounts">- </b>
                {{ billingInformation.subtotal_user_discounts_str }}
              </span>
            </h6>
          </div>

          <div
            slot="actions"
            :class="$style.panel__action"
          >
            <CustomArrow
              :class="$style.panel__action__icon"
              :direction="openedPanelDiscounts === 0 ? 'up' : 'down'"
            />
          </div>

          <hr :class="$style.container__simple">
          <div :class="$style.container__body">
            <p v-if="billingInformation.coupon_discount">
              {{ $t('WIDGETS.BILLING_INFORMATION.COUPON_DISCOUNT') }}
              <span>- {{ billingInformation.coupon_discount_str }}</span>
            </p>
            <p v-if="billingInformation.rappi_pay">
              {{ $t('COMMON.RAPPI_PAY') }}
              <span>- {{ billingInformation.rappi_pay_str }}</span>
            </p>
            <p v-if="billingInformation.rappi_credits">
              {{ $t('COMMON.RAPPI_CREDITS') }}
              <span>- {{ billingInformation.rappi_credits_str }}</span>
            </p>
            <p v-if="billingInformation.prime_discount">
              {{ $t('WIDGETS.BILLING_INFORMATION.PRIME_DISCOUNT') }}
              <span>- {{ billingInformation.prime_discount_str }}</span>
            </p>
            <p v-if="billingInformation.global_offer_discount">
              {{ $t('WIDGETS.BILLING_INFORMATION.PROMOTION_DISCOUNT') }}
              <span>- {{ billingInformation.global_offer_discount_str }}</span>
            </p>
            <p v-if="billingInformation.support_discount">
              {{ $t('WIDGETS.BILLING_INFORMATION.SUPPORT_DISCOUNT') }}
              <span>- {{ billingInformation.support_discount_str }}</span>
            </p>
            <p v-if="billingInformation.product_discount_by_rappi">
              {{ $t('WIDGETS.BILLING_INFORMATION.PRODUCT_DISCOUNT_BY_RAPPI') }}
              <span>- {{ billingInformation.product_discount_by_rappi_str }}</span>
            </p>
            <p v-if="billingInformation.product_discount_by_store">
              {{ $t('WIDGETS.BILLING_INFORMATION.PRODUCT_DISCOUNT_BY_STORE') }}
              <span>- {{ billingInformation.product_discount_by_store_str }}</span>
            </p>
            <hr v-if="billingInformation.subtotal_user_discounts">
            <p
              :class="$style.containerBold">
              {{ $t('WIDGETS.BILLING_INFORMATION.TOTAL_DISCOUNTS') }}
              <span
                :style="{ color: 'red !important' }"
                :class="$style.containerBold"
              ><b v-if="billingInformation.subtotal_user_discounts">- </b>
                {{ billingInformation.subtotal_user_discounts_str }}
              </span>
            </p>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel
        :class="$style.panel"
        v-model="openedPanelTotal"
      >
        <v-expansion-panel-content :class="$style.panel__container">
          <div
            slot="header"
            :class="$style.container__header">
            <h6>
              {{ $t('WIDGETS.BILLING_INFORMATION.TOTAL_PAYMENTS') }}
              <span :style="{ display: openedPanelTotal === 0 ? 'none' : 'block' }">
                {{ billingInformation.total_cost_str }}
              </span>
            </h6>
          </div>

          <div
            slot="actions"
            :class="$style.panel__action"
          >
            <CustomArrow
              :class="$style.panel__action__icon"
              :direction="openedPanelTotal === 0 ? 'up' : 'down'"
            />
          </div>

          <hr :class="$style.container__simple">
          <div :class="$style.container__body">
            <p :class="$style.containerBold">
              {{ $t('PAYMENT_METHOD.'+paymentMethod.toUpperCase()) }}
              <span
                :class="$style.containerBold"
              >{{ billingInformation.total_cost_str }}</span>
            </p>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>
  </div>
</template>

<style scoped lang="scss" module>
@import '@design';
.container {
  text-align: left;
  span {
    float: right;
    margin-right: 1rem;
  }

  h6 {
    margin-bottom: 0;
  }

  p {
    margin: 0;
    font-size: 12px;
    color: #6b6f72;
    text-overflow: ellipsis;
    white-space: nowrap;
    &:last-child {
      font-size: 14px;
    }
  }

  &__simple {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  &__header {
    flex-flow: row wrap;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }

  &__body {
    padding: 15px;
  }

  &Bold {
    font-weight: bold;
    color: black !important;
  }
}

.panel {
  @include remove-borders;

  &__container {
    background-color: $background-container !important;
  }

  &:last-child {
    margin-bottom: 0;
  }

  &__action {
    display: flex;

    &__icon {
      width: 0.5rem;
      height: 0.5rem;
      margin-top: -0.2rem;
    }
  }
}
</style>
